exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader-icon{font-size:28px;color:#8c939d;width:208px;height:208px;line-height:208px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75a16444","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/Payment/Resources/assets/js/views/payment_configurations/index.vue
// module id = 75dQ
// module chunks = 0